import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 'text')?_c(VTextField,_vm._b({on:{"input":_vm.onInput}},'v-text-field',_vm.$attrs,false)):_vm._e(),(_vm.type === 'textarea')?_c(VTextarea,_vm._b({on:{"input":_vm.onInput}},'v-textarea',_vm.$attrs,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }